<template>
	<div
		class="section-container"
		:class="{
			'is-open': isOpen,
		}"
	>
		<div
			class="section-header"
			:class="{ active: isOpen }"
			@click="ToggleSection()"
		>
			<span class="title">
				{{ title }}
			</span>
			<i class="toggle-icon fas fa-chevron-down"></i>
		</div>
		<transition
			name="toggleElement"
			@before-enter="beforeEnter"
			@enter="enter"
			@after-enter="afterEnter"
			@before-leave="beforeLeave"
			@leave="leave"
			@after-leave="afterLeave"
		>
			<div
				v-show="isOpen"
				class="section-body"
			>
				<slot></slot>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		name: 'Section',
		props: {
			title: {
				type: String,
				required: true,
			},
			value: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				isOpen: true,
			}
		},
		watch: {
			value: {
				handler(newVal) {
					this.isOpen = newVal
				},
				immediate: true,
			},
		},
		methods: {
			ToggleSection() {
				this.isOpen = !this.isOpen
				this.$emit('input', this.isOpen)
			},
			beforeEnter(element) {
				element.style.height = '0'
				element.style.overflow = 'hidden'
			},
			enter(element) {
				const height = `${element.scrollHeight}px`
				element.offsetHeight
				element.style.transition = 'height 0.3s ease-in-out'
				element.style.height = height
			},
			afterEnter(element) {
				element.style.height = 'auto'
				element.style.overflow = 'visible'
				element.style.transition = ''
			},
			beforeLeave(element) {
				element.style.height = `${element.scrollHeight}px`
				element.style.overflow = 'hidden'
			},
			leave(element) {
				element.offsetHeight
				element.style.transition = 'height 0.3s ease-in-out'
				element.style.height = '0'
			},
			afterLeave(element) {
				element.style.transition = ''
			},
		},
	}
</script>

<style lang="scss" scoped>
	.section-container {
		--sectionBorderColor: #1e293b;
		--sectionBackgroundColor: #020917;
		font-family: 'Avenir Next Light', 'Avenir Next', 'Avenir Next LT Pro',
			'Avenir', sans-serif;

		width: 100%;
		border-radius: 0.375rem;
		border: 1px solid var(--sectionBorderColor);

		.section-header {
			--fontColor: #94a3b8;

			background-color: var(--sectionBackgroundColor);
			border-radius: 0.375rem 0.375rem 0 0;
			height: 3rem;
			padding: 0.75rem 1rem;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
			cursor: pointer;
			transition: all 0.3s ease-in-out;

			.title {
				color: var(--fontColor);
				font-size: 1rem;
				font-weight: 600;
				letter-spacing: 0.08em;
			}

			.toggle-icon {
				color: var(--fontColor);
				font-size: 0.8rem;
				position: absolute;
				right: 1rem;
				z-index: 2;
				transition: transform 0.1s ease-in-out;
			}

			&:hover,
			&.active {
				.title,
				.toggle-icon {
					color: var(--white);
				}
			}
		}

		.section-body {
			width: 100%;
			height: auto;
			padding: 0.5rem 1rem;
			// overflow: hidden;
			transition: height 0.2s ease-in-out;
		}

		&.is-open {
			.section-header {
				.toggle-icon {
					transform: rotate(180deg);
				}
			}
		}
	}
</style>
